module.exports = __webpack_public_path__ + "static/netlify-swag-logo-f806c69e6689ecf200ed90cff0f09296.svg";